interface WindowProcess {
  env: {
    pageTitle?: string;
  };
}

const __process: WindowProcess = (window as any).process || { env: {} };

export { __process as windowProcess };
